import { render } from "./InquiryCreate.vue?vue&type=template&id=11be0bee&scoped=true"
import script from "./InquiryCreate.vue?vue&type=script&lang=js"
export * from "./InquiryCreate.vue?vue&type=script&lang=js"

import "./InquiryCreate.vue?vue&type=style&index=0&id=11be0bee&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11be0bee"]])

export default __exports__